import { Box, CircularProgress, Grid, Typography } from "@mui/material";

export const FormCancelContract = ({
  qrCode,
  loading,
}: {
  qrCode: string;
  loading: boolean;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <Grid container>
          <Grid item xs={12} sm={6} sx={{ padding: "0 24px" }}>
            <Box
              component="ol"
              sx={{
                marginBottom: "24px",
                padding: "12px",
                color: (theme) => theme.palette.text.primary,
                "& > * ": {
                  fontSize: { xs: "12px", sm: "16px" },
                },
              }}
            >
              <Typography component="li" sx={{ marginBottom: "8px" }}>
                Abra o WhatsApp <strong>no seu celular</strong>
              </Typography>
              <Typography component="li" sx={{ marginBottom: "8px" }}>
                Toque em <strong>Mais opções</strong> no Android ou em{" "}
                <strong>Configurações</strong> no iPhone
              </Typography>
              <Typography component="li" sx={{ marginBottom: "8px" }}>
                Toque em <strong>Dispositivos conectados</strong> e, em seguida,
                em <strong>Conectar dispositivo</strong>
              </Typography>
              <Typography component="li" sx={{ marginBottom: "8px" }}>
                Aponte seu celular para esta tela para escanear o{" "}
                <strong>QR code</strong>
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              alignItems: "center",
              textAlign: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                borderRadius: "8px",
                border: (theme) => `1px solid ${theme.palette.divider}`,
                padding: "12px 12px 6px 12px",
                marginBottom: "16px",
              }}
            >
              <Box
                component="img"
                src={qrCode}
                alt="QR Code"
                sx={{
                  width: "264px",
                  height: "264px",
                }}
              />
            </Box>

            <Typography
              variant="caption"
              sx={{
                color: (theme) => theme.palette.text.primary,
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <span style={{ color: "#05aa05", fontWeight: "bold" }}>✓</span>
              Conexão criptografada neste navegador
            </Typography>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};
